export enum LanguageTypeEnum {
    "pt_PT" = "pt",
    "en_EN" = "en",
    "es_ES" = "es",
}

export enum LanguageEnum {
    "pt_PT" = "pt_PT",
    "en_EN" = "en_EN",
    "es_ES" = "es_ES",
}

export enum LocaleEnum {
    "pt" = "pt",
    "en" = "en",
    "es" = "es",
}
